import axios from '@/libs/api.request'

// 地址搜索（地点搜索）
export const searchPlace = (data) => {
  return axios.request({
    url: 'geocoder/search',
    data: data,
    method: 'post',
  })
}

// 地理编码（地址转经纬度）
export const geocode = (data) => {
  return axios.request({
    url: 'geocoder/geocode',
    data: data,
    method: 'post',
  })
}

// 逆地理编码（经纬度转地址）
export const regeocode = (data) => {
  return axios.request({
    url: 'geocoder/regeocode',
    data: data,
    method: 'post',
  })
}

